import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { PreferenceModel } from '../models/preference.model';
import { Observable, map, of } from 'rxjs';

@Injectable()
export class PreferencesService {
  public introPopupShowedPreference = 'EditorIntroPopupShowed';

  private preferredDocumentFormat: string;

  constructor(private api: ApiService) {
    this.preferredDocumentFormat = '';
  }

  public getDocumentFormat(): Observable<string> {
    if (this.preferredDocumentFormat === '') {
      return this.api.get<PreferenceModel>('preferences/documentformat').pipe(
        map((res: PreferenceModel) => {
          if (res != null) {
            this.preferredDocumentFormat = res.value;
          }
          return this.preferredDocumentFormat;
        })
      );
    } else {
      return of(this.preferredDocumentFormat);
    }
  }

  public getPreference(item: string, userId: string): Observable<string> {
      return this.api.post<PreferenceModel>('preferences/get', {item: item, userId: userId}).pipe(
        map((res: PreferenceModel) => {
          if (res != null) {
            return res.value
          }
          return '';
        })
      );
  }

  public setPreference(item: string, userId: string, value: string): Observable<any> {
    return this.api.post('preferences/set', {item: item, userId: userId, value: value});
  }
}
